import { useOrganStore } from '@/store/modules/organ';
import { ensureToken } from '@/utils/ccflowToken';
import request from '@/utils/request';
// 数据缓存
const cache = {
  loaded: false
};
/**
 * 获取部门
 * @param {*} params
 * @returns
 */
export function listDepts(params) {
  return axios.get('/WF/CFlow/OrgDepts', {
    params: params
  });
}
/**
 * 获取职务
 * @param {*} params
 * @returns
 */
export function listRoles(params) {
  return axios.get('/WF/CFlow/OrgStations', {
    params: params
  });
}
/**
 * 获取职员
 * @param {*} params
 * @returns
 */
export function listUsers(params) {
  return axios.get('/WF/CFlow/OrgEmps', {
    params: params
  });
}
export function getUserDetail(params) {
  const {
    userId
  } = params;
  if (!userId) {
    console.log('userId is null', params);
    return new Promise((resolve, reject) => {
      reject();
    });
  }
  const userDetail = cache[userId];
  if (userDetail) {
    return new Promise((resolve, reject) => {
      resolve({
        code: 1,
        data: userDetail
      });
    });
  } else {
    return request({
      url: '/organ/getUserDetail',
      method: 'get',
      params
    }).then(resp => {
      const {
        code,
        data: detail
      } = resp;
      if (code == 1 && detail && detail.name) {
        cache[userId] = resp.data;
      }
      return resp;
    });
  }
}
export async function getLoginUserDetail(params) {
  return axios.get('/WF/CFlow/Port_Login', {
    params: params
  });
}
export async function loadOrgan() {
  // if (!cache.loaded) {
  const {
    setDepts,
    setRoles,
    setUsers
  } = useOrganStore();
  try {
    const token = await ensureToken(); // 保证有 token
    const param = {
      token: token
    };
    listDepts(param).then(resp => {
      if (resp.code == 200) {
        const depts = JSON.parse(resp.data) || {};
        setDepts(depts);
      }
    });
    listRoles(param).then(resp => {
      if (resp.code == 200) {
        const roles = JSON.parse(resp.data) || {};
        setRoles(roles);
      }
    });
    listUsers(param).then(resp => {
      if (resp.code == 200) {
        const users = JSON.parse(resp.data) || {};
        setUsers(users);
      }
    });
  } catch (err) {
    ElMessage.error('获取审批组件失败');
  }
  //   cache.loaded = true
  // }
}